import { EstadosActivacionInstallOTEnumChoice, gridSizeMdLg10, gridSizeMdLg12, gridSizeMdLg2, gridSizeMdLg4, gridSizeMdLg6, ROUTER_PATHS, texto } from "@/shared";
import { getOrdenTrabajo, OrdenTrabajoQueryKeysEnum, postValidarSeriesEnOrigen, useFetchCajasPrimarias, useFetchCreateTransferenciaInventario, useFetchGetBras, useFetchOLTs, useFetchOrdenTrabajos, useFetchUbicacionProductoSimple, useFetchUbicacionProductosEnabled, useGetContrato, useUpdateAgendamiento, useUpdateContrato, useUpdateOrdenTrabajo } from "@/shared/actions/erp";
import { postCambiarEquipoProvisionamiento, postCrearTrazabilidadCliente, useConsultarAprovisionamiento } from "@/shared/actions/erp/tickets-soporte-cliente";
import OtrosConceptosVisita, { ConceptoVisita, conceptosSinStock } from "@/erp/orden-servicio/orden-servicio-visita/components/otros-conceptos/OtrosConceptosVisita";
import { usePreciosConceptosVisita } from "@/erp/orden-servicio/orden-servicio-visita/components/otros-conceptos/usePreciosConceptosVisita";
import PuntosDeRedVisita, { PuntoRed } from "@/erp/orden-servicio/orden-servicio-visita/components/otros-conceptos/PuntosDeRedVisita";
import TipoInstalacionSelector from "@/erp/orden-servicio/orden-servicio-visita/components/tipo-instalacion/TipoInstalacionSelector";
import FotosVisitaTab from "@/erp/tecnico/orden-trabajo/shared/components/tables/fotos/FotosVisitaTab";
import TiemposVisita from "@/erp/orden-servicio/orden-servicio-visita/components/tiempos/TiemposVisita";
import ReinstalacionAcVisita, { ReinstalacionAc } from "@/erp/orden-servicio/orden-servicio-visita/components/reinstalacion-ac/ReinstalacionAcVisita";
import { useTiposInstalacion, trazaTipoInstalacion, TipoInstalacionSeleccion } from "@/erp/orden-servicio/orden-servicio-visita/components/tipo-instalacion/useTiposInstalacion";
import { CustomAutocompleteNoForm, CustomButtunsRejectConfirm, CustomTextArea, CustomTextField, CustomTextFieldNoForm, SingleFormBoxScene, TabTextLabel } from "@/shared/components/ui";
import { Alert, alpha, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Tooltip, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MemoryIcon from '@mui/icons-material/Memory';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useForm, useWatch} from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ClienteFormComponetVisita from "../../../instalaciones/shared/components/form/components/form-visita/ClienteFormComponetVisita";
import {  ONTOption, OrdenTrabajo } from "@/shared/interfaces";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import { EquiposAdicionalesParaVentaActivaciones } from "../../../instalaciones/shared/components/form/EquiposAdicionalesParaVentaActivaciones";
import EngineeringIcon from '@mui/icons-material/Engineering';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RefreshIcon from '@mui/icons-material/Refresh';
import { CategoryProducCodeEnum } from "@/shared/interfaces/erp/inventario";
import { toast } from "react-toastify";
import { useQueryClient, useQuery } from "@tanstack/react-query";
import { hasPermission } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import { useRecordDirectLock } from "@/shared/hooks/useRecordDirectLock";
import { useFetchRouters } from "@/store/erp";
import { useAuthStore } from "@/store/auth";

const getCodeFromValue = (...values: any[]) => {
    for (const value of values) {
        if (value === undefined || value === null) continue;
        if (typeof value === "string") {
            if (value.trim() !== "") return value;
            continue;
        }
        if (typeof value === "object") {
            const code =
                value.codigo ||
                value.id_ubicacion ||
                value.id_bodega ||
                value.id ||
                value.numero_referencia ||
                "";
            if (String(code).trim() !== "") return String(code);
            continue;
        }

        if (String(value).trim() !== "") return String(value);
    }

    return "";
};

const isBlank = (value: any) => value === undefined || value === null || String(value).trim() === "";

const getOntSerialFromData = (value: any) => {
    if (isBlank(value)) return "";
    if (typeof value === "string") return value.trim();

    const candidates = [
        value?.serial,
        value?.serie,
        value?.serie_mac,
        value?.serie_num,
        value?.value?.serial,
        value?.value?.serie,
        value?.value?.series?.[0],
        value?.series?.[0],
    ];

    for (const candidate of candidates) {
        if (!isBlank(candidate)) return String(candidate).trim();
    }

    return "";
};

const normalizeOntSerial = (value: any) => getOntSerialFromData(value).toUpperCase();

const getTicketContractCode = (...values: any[]) => {
    for (const value of values) {
        if (isBlank(value)) continue;
        const textValue = String(value).trim();
        if (/^SN-\d+$/i.test(textValue)) return textValue.toUpperCase();
        if (/^\d+$/.test(textValue)) return `SN-${textValue}`;
    }

    return "";
};

const missingFieldLabels: Record<string, string> = {
    "observacion_cambio_ont.ont_actual": "ONT actual seleccionada por el técnico",
    "bodega_origen": "bodega origen del técnico",
    "ubicacion_origen": "ubicación origen del técnico",
    "bodega_destino": "bodega destino del cliente",
    "ubicacion_destino": "ubicación destino del cliente",
    "productos[0].id": "ONT nueva seleccionada",
    "productos[0].codigo": "ONT nueva seleccionada",
    "productos[0].series[0]": "ONT nueva seleccionada",
    "user": "usuario logueado",
    "nombre_cliente": "nombre del cliente",
    "identificacion": "identificación del cliente",
    "datos.serial_ont": "serie de la ONT actual",
    "datos.service_profile": "perfil de servicio actual",
    "datos.mac_ont": "MAC de la ONT actual",
    "datos.nombre_olt": "nombre de la OLT",
    "datos.ip_olt": "IP de la OLT",
    "datos.ont_id": "ONT ID",
    "datos.service_port_id_custom": "service port custom",
    "datos.service_port_id_tr069": "service port TR069",
    "datos.puerto_pon": "puerto PON",
    "datos.estado_servicio": "estado del servicio",
    "datos.serial_ont_nuevo": "serie de la ONT nueva",
    "datos.service_profile_nuevo": "perfil de servicio nuevo",
    "datos.user": "usuario PPPoE",
    "datos.password": "contraseña PPPoE",
    "datos.ssid": "SSID",
    "datos.vlan": "VLAN",
    "us_creacion": "usuario que realiza el cambio",
};

const formatMissingFields = (fields: string[]) => {
    const readableFields = fields.map((field) => missingFieldLabels[field] || field);
    return Array.from(new Set(readableFields)).join(", ");
};

const getFirstNonBlank = (...values: any[]) => {
    for (const value of values) {
        if (isBlank(value)) continue;

        if (typeof value === "object") {
            const objectCandidates = [
                value.nombre,
                value.name,
                value.label,
                value.descripcion,
                value.codigo,
                value.value?.nombre,
                value.value?.name,
                value.value?.label,
                value.value?.descripcion,
                value.value?.codigo,
            ];

            for (const candidate of objectCandidates) {
                if (!isBlank(candidate)) return String(candidate).trim();
            }

            continue;
        }

        return String(value).trim();
    }

    return "";
};

const getProvisionamientoErrorMessage = (error: any) => {
    const responseData = error?.response?.data;
    const responseStatus = error?.response?.status;
    const message =
        responseData?.message ||
        responseData?.mensaje ||
        responseData?.data?.message ||
        responseData?.data?.mensaje;

    if (!isBlank(message)) return String(message);
    if (responseStatus === 504) return "El servicio de provisionamiento no respondió a tiempo. Intente nuevamente más tarde.";
    if (responseStatus === 502) return "No se pudo acceder al servicio de provisionamiento. Intente nuevamente más tarde.";
    if (error?.code === "ERR_NETWORK") return "No se pudo acceder al servicio de provisionamiento.";

    return "No se pudo completar el cambio de equipo en provisionamiento.";
};

const getApiErrorMessage = (error: any, fallback: string) => {
    const responseData = error?.response?.data;
    const message =
        responseData?.message ||
        responseData?.mensaje ||
        responseData?.data?.message ||
        responseData?.data?.mensaje;

    if (!isBlank(message)) return String(message);
    return fallback;
};

const getTrasladoInventarioResponseData = (response: any) => response?.data?.data || response?.data || response || {};

const getTrasladoInventarioPdfUrl = (response: any) => {
    const data = getTrasladoInventarioResponseData(response);
    return getFirstNonBlank(data?.url_pdf, data?.urlPdf, data?.pdf_url, data?.pdfUrl);
};

export type SaveActivacionesVisitaPendingOTProps = {
    titlePage?: string
    ordenTrabajo: OrdenTrabajo
    customReturnUrl?: string
    /** Activaciones (módulo ACTIVACIONES.VISITA) puede eliminar fotos del técnico. */
    canDeleteFotos?: boolean
}

type CambioOntDialogState = {
    open: boolean;
    severity: "error" | "warning" | "success" | "info";
    title: string;
    message: string;
    details?: string[];
};

export default function SaveActivacionesVisitaPendingOT({
    titlePage,
    ordenTrabajo,
    customReturnUrl = ROUTER_PATHS.activaciones.activacionesVisitaNav,
    canDeleteFotos = false,
}: SaveActivacionesVisitaPendingOTProps) {
    const navigate = useNavigate()
    const id = ordenTrabajo.id_orden_trabajo
    const currentUser = useAuthStore((s) => s.user);
    const user = currentUser;
    const queryClient = useQueryClient()

    // Recarga SOLO los datos de la OT (sin recargar la página) — refleja lo que el
    // técnico agregó/cambió (puntos de red, series). Igual que "Actualizar" del técnico.
    const [actualizando, setActualizando] = useState(false)
    const refrescarDatos = async () => {
        setActualizando(true)
        try {
            await queryClient.invalidateQueries({
                queryKey: [OrdenTrabajoQueryKeysEnum.OrdenTrabajo, id?.toString() || ""],
            })
        } finally {
            setActualizando(false)
        }
    }

    // Liberar OT del técnico: quita el lock del registro (solo admin). Igual que
    // en activaciones de instalación.
    const { releaseLock } = useRecordDirectLock(id?.toString() || "")
    const [liberando, setLiberando] = useState(false)
    const liberarOTTecnico = async () => {
        setLiberando(true)
        try {
            await releaseLock()
            toast.success("Orden de Trabajo del técnico liberada. El técnico puede continuar.")
        } catch (e) {
            console.error("No se pudo liberar la OT", e)
            toast.error("No se pudo liberar la OT del técnico.")
        } finally {
            setLiberando(false)
        }
    }

    const form = useForm<any>({
        defaultValues: {
            estado: true
        }
    })
    //console.log('equipos utilizados',ordenTrabajo.equipos_utilizados?.length)
    const [optionsONT, setOptionsONT] = useState<ONTOption[]>([]);
    const [cambioOntDialog, setCambioOntDialog] = useState<CambioOntDialogState>({
        open: false,
        severity: "info",
        title: "",
        message: "",
    });
    const [trasladoInventarioPdfUrl, setTrasladoInventarioPdfUrl] = useState(
        getFirstNonBlank(ordenTrabajo?.observaciones?.observacion_cambio_ont?.traslado_inventario?.url_pdf)
    );
    const ontAUtilizar = useWatch({ control: form.control, name: "ont_a_utilizar" });

    useEffect(() => {
        setTrasladoInventarioPdfUrl(
            getFirstNonBlank(ordenTrabajo?.observaciones?.observacion_cambio_ont?.traslado_inventario?.url_pdf)
        );
    }, [ordenTrabajo?.observaciones?.observacion_cambio_ont?.traslado_inventario?.url_pdf]);

    const showCambioOntDialog = (dialog: Omit<CambioOntDialogState, "open">) => {
        setCambioOntDialog({ ...dialog, open: true });
    };

    const updateOT = useUpdateOrdenTrabajo<any>({
        navigate,
        returnUrl: customReturnUrl,
        customMessage: "Activación de visita completada"
    })

    const updateOTNoReturn = useUpdateOrdenTrabajo<any>({
        enableRedirect: false,
        enableSuccessAlert: false,
        enableErrorAlert: false,
    })

    const updateContratoNavegacion = useUpdateContrato<any>({ enableRedirect: false, enableSuccessAlert: false, enableErrorAlert: false })
    const trasladoInventarioMutation = useFetchCreateTransferenciaInventario();

    // "Otros conceptos" viven en el AGENDAMIENTO. Activaciones puede editarlos
    // mientras la OT esté Pendiente / Pendiente Recoordinada (no GESTIONADA ni
    // RECHAZADA). Se persisten en agendamiento.observaciones.otros_conceptos.
    const { conceptos: catalogoConceptos, puntoRed: puntoRedConfig, ivaPorcentaje: ivaPorcentajePR, metodosPago } = usePreciosConceptosVisita()
    const { tipos: tiposInstalacion } = useTiposInstalacion()
    const [tipoInstalacion, setTipoInstalacion] = useState<TipoInstalacionSeleccion | null>(null)
    const [reinstalacionAc, setReinstalacionAc] = useState<ReinstalacionAc | null>(null)

    // Poll LIGERO solo para los tiempos del técnico (inicio/fin), en tiempo real,
    // SIN tocar la prop `ordenTrabajo` que alimenta el form/estado de edición (por
    // eso es un query aparte: refresca los tiempos sin resetear lo que Activaciones
    // esté editando). Refleja cuando el técnico inicia y finaliza la visita.
    const { data: tiemposRes } = useQuery({
        queryKey: ['activ-visita-tiempos', ordenTrabajo?.id_orden_trabajo],
        queryFn: () => getOrdenTrabajo(ordenTrabajo?.id_orden_trabajo!),
        enabled: !!ordenTrabajo?.id_orden_trabajo,
        refetchInterval: 8000,
        refetchOnWindowFocus: true,
    })
    const otTiempos = ((tiemposRes as any)?.data as OrdenTrabajo) || ordenTrabajo
    const updateAgendamientoConceptos = useUpdateAgendamiento<any>({ enableRedirect: false, enableSuccessAlert: false, enableErrorAlert: false })
    const [conceptos, setConceptos] = useState<ConceptoVisita[]>([])
    // Puntos de red (ingresados por el técnico; activaciones puede editar/aprobar).
    const [puntosRed, setPuntosRed] = useState<PuntoRed[]>([])
    const _hayCableUtpMateriales = (Array.isArray((ordenTrabajo as any)?.materiales_utilizados)
        ? (ordenTrabajo as any).materiales_utilizados
        : []
    ).some((m: any) => {
        const cod = (m?.codigo || m?.producto_data?.codigo || "").toUpperCase()
        const desc = (m?.descripcion || m?.producto_data?.descripcion || "").toUpperCase()
        return cod.startsWith("PDR.017") || desc.includes("CABLE UTP")
    })
    // Si el técnico ya ingresó puntos de red, implica que había cable UTP; se
    // permite a activaciones editar/quitar aunque los materiales aún no estén
    // guardados en la OT.
    const tieneCableUtpAct = _hayCableUtpMateriales || puntosRed.length > 0
    const puntosRedAprobadoAct = !!(ordenTrabajo as any)?.agendamiento_data?.observaciones?.puntos_red_aprobado

    // Dirty tracking: los botones "Guardar" solo se activan si hay cambios sin
    // guardar respecto de lo persistido en el agendamiento (se refresca al guardar).
    const _obsOrigAct = (ordenTrabajo as any)?.agendamiento_data?.observaciones || {}
    const _origConceptosAct = Array.isArray(_obsOrigAct?.otros_conceptos) ? _obsOrigAct.otros_conceptos : []
    const _origPuntosAct = Array.isArray(_obsOrigAct?.puntos_red) ? _obsOrigAct.puntos_red : []
    const _origTipoAct = _obsOrigAct?.tipo_instalacion || null
    const _origReinstalacionAct = _obsOrigAct?.reinstalacion_ac || null
    const conceptosDirtyAct = JSON.stringify(_origConceptosAct) !== JSON.stringify(conceptos)
    const puntosDirtyAct = JSON.stringify(_origPuntosAct) !== JSON.stringify(puntosRed)
    const tipoDirtyAct = JSON.stringify(_origTipoAct) !== JSON.stringify(tipoInstalacion || null)
    const reinstalacionDirtyAct = JSON.stringify(_origReinstalacionAct) !== JSON.stringify(reinstalacionAc || null)
    const hayCambiosAct = conceptosDirtyAct || puntosDirtyAct || tipoDirtyAct || reinstalacionDirtyAct
    const puedeEditarConceptos = ![
        EstadosActivacionInstallOTEnumChoice.GESTIONADA,
        EstadosActivacionInstallOTEnumChoice.RECHAZADA,
    ].includes(ordenTrabajo?.estado_activacion as any)

    // Stock por producto en la ubicación de la flota (para avisar si no alcanza
    // al llegar a activaciones). El inventario es referencia hasta completar.
    const ubicacionFlotaAct = ordenTrabajo?.flota_data?.ubicacion
    const { data: invStockData, isLoading: invStockLoading } = useFetchUbicacionProductoSimple({
        enabled: !!ubicacionFlotaAct,
        params: {
            page: 1,
            page_size: 500,
            estado: true,
            filterByState: false,
            es_para_venta: true,
            ubicacion: ubicacionFlotaAct,
        } as any,
    })
    const stockPorProducto = useMemo(() => {
        const m: Record<string, number> = {}
        const arr = (invStockData as any)?.data?.data || []
        for (const up of arr) {
            const idp = up?.producto_data?.id_producto || up?.id
            if (idp) m[idp] = Number(up?.cantidad ?? 0)
        }
        return m
    }, [invStockData])

    const ubicacionProductosParams = useMemo(() => ({
        categoria_producto: CategoryProducCodeEnum.EQUIPOS,
        ubicacion: ordenTrabajo?.flota_data?.ubicacion,
        es_ont: true,
    }), [ordenTrabajo?.flota_data?.ubicacion]);
    //console.log('ubciacionParamas', ubicacionProductosParams)

    const {
        data: dataUbicacionProd,
        isLoading: isloadingUbProducto

    } = useFetchUbicacionProductosEnabled({
        enabled: !!ordenTrabajo?.flota_data?.ubicacion,
        params: ubicacionProductosParams
    });

    useEffect(() => {
        if (!dataUbicacionProd?.data?.data) return;
        const auxONTOptions = dataUbicacionProd.data.data
            .filter((item: any) => item?.producto_data?.es_ont)
            .map((item: any) => {
                const auxONT = item?.series
                const auxONTData: any[] = []
                auxONT?.forEach((ont: string) => {
                    const auxONTSplit = ont.split('-')
                    auxONTData.push({
                        name: `${item.producto_data?.descripcion} - ${auxONTSplit[auxONTSplit.length - 1]}`,
                        id: item.producto_data?.id_producto || item.id || item.producto,
                        codigo: item.producto_data?.codigo,
                        cantidad: "1",
                        series: [ont],
                        bodega: item.bodega,
                        ubicacion: item.ubicacion,
                        bodega_data: item.bodega_data,
                        ubicacion_data: item.ubicacion_data,
                        contiene_serie: true,
                        usa_metros: false,
                        value: {
                            id: item.producto_data?.id_producto || item.id || item.producto,
                            codigo: item.producto_data?.codigo,
                            cantidad: 1,
                            series: [ont],
                            descripcion: item.producto_data?.descripcion,
                            service_profile: item.producto_data?.service_profile,
                            producto_data: item.producto_data,
                            stock_actual: item.stock,
                            bodega: item.bodega,
                            ubicacion: item.ubicacion,
                            bodega_data: item.bodega_data,
                            ubicacion_data: item.ubicacion_data,
                        },
                    })
                })
                return auxONTData
            })
        setOptionsONT(auxONTOptions?.flat() || []);
    }, [dataUbicacionProd])

    useEffect(() => {
        if (!ordenTrabajo) return
        form.reset({
            ...ordenTrabajo,
            //serie_ont_nueva: ordenTrabajo?.serie_ont_nueva || "",
            ont_a_utilizar: ordenTrabajo?.equipos_utilizados?.[0] || null,
            estado_navegacion: ordenTrabajo?.contrato_data?.estado_navegacion || "",
        })
        const conceptosAg =
            (ordenTrabajo as any)?.agendamiento_data?.observaciones?.otros_conceptos ||
            (ordenTrabajo as any)?.observaciones?.otros_conceptos ||
            []
        setConceptos(Array.isArray(conceptosAg) ? conceptosAg : [])
        const puntosAg =
            (ordenTrabajo as any)?.agendamiento_data?.observaciones?.puntos_red ||
            (ordenTrabajo as any)?.observaciones?.puntos_red ||
            []
        setPuntosRed(Array.isArray(puntosAg) ? puntosAg : [])
        const tipoAg =
            (ordenTrabajo as any)?.agendamiento_data?.observaciones?.tipo_instalacion ||
            (ordenTrabajo as any)?.observaciones?.tipo_instalacion ||
            null
        setTipoInstalacion(tipoAg)
        const reinstAg =
            (ordenTrabajo as any)?.agendamiento_data?.observaciones?.reinstalacion_ac ||
            (ordenTrabajo as any)?.observaciones?.reinstalacion_ac ||
            null
        setReinstalacionAc(reinstAg)
    }, [ordenTrabajo])
    //contrato
    const contratoId = ordenTrabajo?.contrato_data?.id_contrato
    const {
        data: dataContrato,
        isLoading: isLoadingContrato
    } = useGetContrato(contratoId!, !!contratoId)

    const clienteIdentificacion = useMemo(() => {
        const ordenCliente = (ordenTrabajo as any)?.cliente_data || {};
        const contratoResueltoCliente = (dataContrato as any)?.data?.cliente_data || {};
        const contratoCliente = (ordenTrabajo?.contrato_data?.cliente_data as any) || {};
        const prospecto = (ordenTrabajo?.prospecto_data as any) || {};
        const preventa = (ordenTrabajo?.preventa_data as any) || {};
        return (
            ordenCliente.identificacion ||
            ordenCliente.cedula ||
            contratoResueltoCliente.identificacion ||
            contratoResueltoCliente.cedula ||
            contratoCliente.identificacion ||
            contratoCliente.cedula ||
            prospecto.identificacion ||
            prospecto.cedula ||
            preventa.identificacion ||
            preventa.cedula ||
            ""
        );
    }, [dataContrato, ordenTrabajo]);

    const ontActualGuardada =
        ordenTrabajo?.observaciones?.observacion_cambio_ont?.ont_actual;

    const contratoCodigoAprovisionamiento = useMemo(() => {
        const contrato = (ordenTrabajo?.contrato_data as any) || {};
        return getTicketContractCode(
            ontActualGuardada?.contrato,
            ontActualGuardada?.value?.contrato,
            contrato.codigo,
            contrato.numero_referencia,
            contrato.contrato_eva
        );
    }, [ontActualGuardada, ordenTrabajo]);

    const {
        data: aprovisionamientoRes,
        isLoading: isLoadingAprovisionamiento,
    } = useConsultarAprovisionamiento(
        {
            identificacion: clienteIdentificacion,
            contrato: contratoCodigoAprovisionamiento,
            id_instalacion: (ordenTrabajo?.contrato_data as any)?.id_instalacion,
            contrato_eva: (ordenTrabajo?.contrato_data as any)?.contrato_eva,
        },
        !!ordenTrabajo?.requiere_cambio_ont && !!clienteIdentificacion
    );

    const aprovisionamiento = useMemo(() => {
        const responseData = (aprovisionamientoRes as any)?.data;
        const rawData = responseData?.data ?? responseData;
        if (Array.isArray(rawData)) return rawData[0] || null;
        return rawData || null;
    }, [aprovisionamientoRes]);

    const aprovisionamientoDatos = aprovisionamiento?.datos || {};
    const selectedNewOnt = ontAUtilizar || form.getValues().ont_a_utilizar || ordenTrabajo?.equipos_utilizados?.[0];
    const serialOntNueva = getOntSerialFromData(selectedNewOnt);
    const serviceProfileNuevo =
        selectedNewOnt?.value?.service_profile ||
        selectedNewOnt?.service_profile ||
        aprovisionamientoDatos?.service_profile ||
        "";
    const productoOntNueva =
        selectedNewOnt?.value?.codigo ||
        selectedNewOnt?.codigo ||
        "";
    const productoIdOntNueva =
        selectedNewOnt?.value?.id ||
        selectedNewOnt?.id ||
        selectedNewOnt?.value?.producto_data?.id_producto ||
        selectedNewOnt?.producto_data?.id_producto ||
        "";
    const serialOntActual =
        getOntSerialFromData(ontActualGuardada) ||
        ordenTrabajo?.contrato_data?.serie_ont ||
        ordenTrabajo?.serie_ont ||
        aprovisionamientoDatos?.serial_ont ||
        "";
    const esMismaOntActualYNueva =
        !!serialOntActual &&
        !!serialOntNueva &&
        normalizeOntSerial(serialOntActual) === normalizeOntSerial(serialOntNueva);

    const bodegaOrigenTraslado = getCodeFromValue(
        selectedNewOnt?.value?.bodega,
        selectedNewOnt?.bodega,
        selectedNewOnt?.value?.bodega_data,
        selectedNewOnt?.bodega_data,
        ordenTrabajo?.flota_data?.bodega,
        ordenTrabajo?.flota_data?.bodega_data
    );
    const ubicacionOrigenTraslado = getCodeFromValue(
        selectedNewOnt?.value?.ubicacion,
        selectedNewOnt?.ubicacion,
        selectedNewOnt?.value?.ubicacion_data,
        selectedNewOnt?.ubicacion_data,
        ordenTrabajo?.flota_data?.ubicacion,
        ordenTrabajo?.flota_data?.ubicacion_data
    );
    const contratoDataResolved = (dataContrato as any)?.data || {};
    const contratoDataOrden = (ordenTrabajo?.contrato_data as any) || {};
    const clienteDataContrato = contratoDataResolved?.cliente_data || {};
    const clienteDataOrden = (ordenTrabajo as any)?.cliente_data || contratoDataOrden?.cliente_data || {};
    const ubicacionDestinoTraslado = getCodeFromValue(
        contratoDataResolved?.ubicacion,
        contratoDataResolved?.ubicacion_id,
        contratoDataResolved?.ubicacion_data,
        contratoDataOrden?.ubicacion,
        contratoDataOrden?.ubicacion_id,
        contratoDataOrden?.ubicacion_data,
        clienteDataContrato?.ubicacion,
        clienteDataContrato?.ubicacion_id,
        clienteDataContrato?.ubicacion_data,
        clienteDataOrden?.ubicacion,
        clienteDataOrden?.ubicacion_id,
        clienteDataOrden?.ubicacion_data
    );
    const bodegaDestinoTraslado = getCodeFromValue(
        contratoDataResolved?.bodega,
        contratoDataResolved?.bodega_id,
        contratoDataResolved?.bodega_data,
        contratoDataResolved?.ubicacion_data?.bodega,
        contratoDataResolved?.ubicacion_data?.bodega_data,
        contratoDataOrden?.bodega,
        contratoDataOrden?.bodega_id,
        contratoDataOrden?.bodega_data,
        contratoDataOrden?.ubicacion_data?.bodega,
        contratoDataOrden?.ubicacion_data?.bodega_data,
        clienteDataContrato?.bodega,
        clienteDataContrato?.bodega_id,
        clienteDataContrato?.bodega_data,
        clienteDataContrato?.ubicacion_data?.bodega,
        clienteDataContrato?.ubicacion_data?.bodega_data,
        clienteDataOrden?.bodega,
        clienteDataOrden?.bodega_id,
        clienteDataOrden?.bodega_data,
        clienteDataOrden?.ubicacion_data?.bodega,
        clienteDataOrden?.ubicacion_data?.bodega_data
    );

    const productoDataTraslado = selectedNewOnt?.value?.producto_data || selectedNewOnt?.producto_data || {};
    const payloadTrasladoInventario = useMemo(() => ({
        es_transito: false,
        bodega_origen_externa: true,
        bodega_destino_externa: true,
        solicitado_por: currentUser?.razon_social || currentUser?.username || "",
        fecha_solicitud_transferencia: dayjs().format("YYYY-MM-DD hh:mm A"),
        bodega_origen: bodegaOrigenTraslado,
        ubicacion_origen: ubicacionOrigenTraslado,
        bodega_destino: bodegaDestinoTraslado,
        ubicacion_destino: ubicacionDestinoTraslado,
        motivo: "INVENTARIO_TRASLADO",
        unidad_transporte: "002",
        observacion_1: `Cambio de ONT OT ${ordenTrabajo?.numero_referencia || ordenTrabajo?.codigo || id}`,
        fecha_actual_fronted: dayjs().toISOString(),
        productos: [{
            id: productoIdOntNueva,
            codigo: productoOntNueva,
            cantidad: "1",
            producto_data: {
                codigo: productoOntNueva,
                categoria_producto: productoDataTraslado?.categoria_producto,
                subcategoria_producto: productoDataTraslado?.subcategoria_producto,
                stock_actual: productoDataTraslado?.stock_actual || selectedNewOnt?.value?.stock_actual || selectedNewOnt?.stock || "1",
                descripcion: productoDataTraslado?.descripcion || selectedNewOnt?.value?.descripcion || selectedNewOnt?.name || "",
                modelo_producto: productoDataTraslado?.modelo_producto,
                marca_producto: productoDataTraslado?.marca_producto,
                unidad_medida: productoDataTraslado?.unidad_medida,
                presentacion: productoDataTraslado?.presentacion,
            },
            contiene_serie: true,
            series: serialOntNueva ? [serialOntNueva] : [],
            usa_metros: false,
            ubicacion_origen: ubicacionOrigenTraslado,
            ubicacion_destino: ubicacionDestinoTraslado,
            cantidad_metros: "0",
            series_metros: {},
            url_archivo: null,
        }],
        user: currentUser?.username || "",
        observaciones: {
            observaciones_1: `Cambio de ONT OT ${ordenTrabajo?.numero_referencia || ordenTrabajo?.codigo || id}`,
        },
        trasalado_inicial: null,
        fecha: dayjs().format("YYYY-MM-DD"),
    }), [
        bodegaDestinoTraslado,
        bodegaOrigenTraslado,
        currentUser?.razon_social,
        currentUser?.username,
        id,
        ordenTrabajo?.codigo,
        ordenTrabajo?.numero_referencia,
        productoDataTraslado,
        productoIdOntNueva,
        productoOntNueva,
        selectedNewOnt,
        serialOntNueva,
        ubicacionDestinoTraslado,
        ubicacionOrigenTraslado,
    ]);

    const camposFaltantesTrasladoInventario = useMemo(() => {
        const requiredFields: Array<[string, any]> = [
            ["observacion_cambio_ont.ont_actual", ontActualGuardada],
            ["bodega_origen", payloadTrasladoInventario.bodega_origen],
            ["ubicacion_origen", payloadTrasladoInventario.ubicacion_origen],
            ["bodega_destino", payloadTrasladoInventario.bodega_destino],
            ["ubicacion_destino", payloadTrasladoInventario.ubicacion_destino],
            ["productos[0].id", payloadTrasladoInventario.productos[0]?.id],
            ["productos[0].codigo", payloadTrasladoInventario.productos[0]?.codigo],
            ["productos[0].series[0]", payloadTrasladoInventario.productos[0]?.series?.[0]],
            ["user", payloadTrasladoInventario.user],
        ];

        return requiredFields
            .filter(([, value]) => isBlank(value))
            .map(([field]) => field);
    }, [ontActualGuardada, payloadTrasladoInventario]);

    const payloadCambioEquipo = useMemo(() => {
        const contratoDataCambioEquipo = (ordenTrabajo?.contrato_data as any) || {};
        const macOnt = aprovisionamientoDatos?.mac_ont;
        const lineProfile = aprovisionamientoDatos?.line_profile;
        const trafficTable = aprovisionamientoDatos?.traffic_table;
        const gemPort = aprovisionamientoDatos?.gem_port;
        const potencia = aprovisionamientoDatos?.potencia;
        const tipoNegocioActual = getFirstNonBlank(
            aprovisionamientoDatos?.tipo_negocio_actual,
            aprovisionamiento?.tipo_negocio_actual,
            contratoDataCambioEquipo?.tipo_negocio_actual,
            contratoDataCambioEquipo?.tipo_contrato,
            contratoDataCambioEquipo?.tipo_contrato_data?.nombre,
            (ordenTrabajo as any)?.tipo_contrato
        );
        const capacidadUp = aprovisionamientoDatos?.capacidad_up;
        const capacidadDown = aprovisionamientoDatos?.capacidad_down;
        const nombreCliente =
            aprovisionamiento?.nombre_cliente ||
            contratoDataCambioEquipo?.cliente_data?.razon_social ||
            ordenTrabajo?.prospecto_data?.razon_social ||
            "";

        return {
            nombre_cliente: String(nombreCliente || "").trim().replace(/\s+/g, "_").slice(0, 124),
            identificacion: clienteIdentificacion,
            datos: {
                serial_ont: serialOntActual,
                ...(!isBlank(macOnt) ? { mac_ont: macOnt } : {}),
                nombre_olt: aprovisionamientoDatos?.nombre_olt || "",
                ip_olt: aprovisionamientoDatos?.ip_olt || "",
                ont_id: aprovisionamientoDatos?.ont_id || "",
                service_profile: aprovisionamientoDatos?.service_profile || "",
                service_port_id_custom: aprovisionamientoDatos?.service_port_id_custom || "",
                service_port_id_tr069: aprovisionamientoDatos?.service_port_id_tr069 || "",
                puerto_pon: aprovisionamientoDatos?.puerto_pon || "",
                serial_ont_nuevo: serialOntNueva,
                service_profile_nuevo: serviceProfileNuevo,
                ...(!isBlank(lineProfile) ? { line_profile: lineProfile } : {}),
                ...(!isBlank(trafficTable) ? { traffic_table: trafficTable } : {}),
                ...(!isBlank(gemPort) ? { gem_port: gemPort } : {}),
                ...(!isBlank(potencia) ? { potencia } : {}),
                estado_servicio: getFirstNonBlank(
                    aprovisionamientoDatos?.estado_servicio,
                    aprovisionamiento?.estado_servicio,
                    contratoDataCambioEquipo?.estado_servicio,
                    contratoDataCambioEquipo?.estado_navegacion
                ),
                ...(!isBlank(tipoNegocioActual) ? { tipo_negocio_actual: tipoNegocioActual } : {}),
                ...(!isBlank(capacidadUp) ? { capacidad_up: capacidadUp } : {}),
                ...(!isBlank(capacidadDown) ? { capacidad_down: capacidadDown } : {}),
                user: aprovisionamientoDatos?.user || "",
                password: aprovisionamientoDatos?.password || "",
                ssid: aprovisionamientoDatos?.ssid || "",
                vlan: aprovisionamientoDatos?.vlan || "",
            },
            us_creacion: currentUser?.username || "",
        };
    }, [
        aprovisionamiento,
        aprovisionamientoDatos,
        clienteIdentificacion,
        currentUser?.username,
        ordenTrabajo,
        serialOntActual,
        serialOntNueva,
        serviceProfileNuevo,
    ]);

    const payloadCambioEquipoReversa = useMemo(() => {
        const datosSinMac = { ...((payloadCambioEquipo.datos || {}) as any) };
        delete datosSinMac.mac_ont;

        return {
            ...payloadCambioEquipo,
            datos: {
                ...datosSinMac,
                serial_ont: payloadCambioEquipo.datos.serial_ont_nuevo,
                serial_ont_nuevo: payloadCambioEquipo.datos.serial_ont,
                service_profile: payloadCambioEquipo.datos.service_profile_nuevo || payloadCambioEquipo.datos.service_profile,
                service_profile_nuevo: payloadCambioEquipo.datos.service_profile || payloadCambioEquipo.datos.service_profile_nuevo,
            },
        };
    }, [payloadCambioEquipo]);

    const camposFaltantesCambioEquipo = useMemo(() => {
        const requiredFields: Array<[string, any]> = [
            ["nombre_cliente", payloadCambioEquipo.nombre_cliente],
            ["identificacion", payloadCambioEquipo.identificacion],
            ["datos.serial_ont", payloadCambioEquipo.datos.serial_ont],
            ["datos.service_profile", payloadCambioEquipo.datos.service_profile],
            ["datos.nombre_olt", payloadCambioEquipo.datos.nombre_olt],
            ["datos.ip_olt", payloadCambioEquipo.datos.ip_olt],
            ["datos.ont_id", payloadCambioEquipo.datos.ont_id],
            ["datos.service_port_id_custom", payloadCambioEquipo.datos.service_port_id_custom],
            ["datos.service_port_id_tr069", payloadCambioEquipo.datos.service_port_id_tr069],
            ["datos.puerto_pon", payloadCambioEquipo.datos.puerto_pon],
            ["datos.serial_ont_nuevo", payloadCambioEquipo.datos.serial_ont_nuevo],
            ["datos.service_profile_nuevo", payloadCambioEquipo.datos.service_profile_nuevo],
            ["datos.estado_servicio", payloadCambioEquipo.datos.estado_servicio],
            ["datos.user", payloadCambioEquipo.datos.user],
            ["datos.password", payloadCambioEquipo.datos.password],
            ["datos.ssid", payloadCambioEquipo.datos.ssid],
            ["datos.vlan", payloadCambioEquipo.datos.vlan],
            ["us_creacion", payloadCambioEquipo.us_creacion],
        ];

        return requiredFields
            .filter(([, value]) => value === undefined || value === null || String(value).trim() === "")
            .map(([field]) => field);
    }, [payloadCambioEquipo]);

    const clienteIdTrazabilidad = getFirstNonBlank(
        clienteDataOrden?.id_cliente,
        clienteDataOrden?.id,
        clienteDataContrato?.id_cliente,
        clienteDataContrato?.id,
        contratoDataOrden?.cliente_data?.id_cliente,
        contratoDataOrden?.cliente_id,
        contratoDataOrden?.cliente,
        contratoDataResolved?.cliente_data?.id_cliente,
        contratoDataResolved?.cliente_id,
        contratoDataResolved?.cliente
    );

    const contratoIdTrazabilidad = getFirstNonBlank(
        contratoDataResolved?.id_contrato,
        contratoDataOrden?.id_contrato,
        contratoId
    );

    const contratoCodigoTrazabilidad = getFirstNonBlank(
        contratoCodigoAprovisionamiento,
        contratoDataResolved?.codigo,
        contratoDataResolved?.numero_referencia,
        contratoDataOrden?.codigo,
        contratoDataOrden?.numero_referencia,
        contratoDataOrden?.contrato_eva
    );

    const registrarTrazabilidadCambioOnt = async ({
        trasladoData,
        trasladoPdfUrl,
    }: {
        trasladoData: any;
        trasladoPdfUrl: string;
    }) => {
        if (isBlank(clienteIdTrazabilidad) || isBlank(contratoIdTrazabilidad)) {
            console.warn("No se registró trazabilidad de cambio de ONT: faltan ids de cliente o contrato.", {
                clienteIdTrazabilidad,
                contratoIdTrazabilidad,
            });
            return false;
        }

        const codigoTraslado = getFirstNonBlank(
            trasladoData?.data?.codigo,
            trasladoData?.codigo,
            trasladoData?.data?.numero_referencia,
            trasladoData?.numero_referencia
        );
        const idTraslado = getFirstNonBlank(
            trasladoData?.data?.id_traslado_inventario,
            trasladoData?.id_traslado_inventario
        );
        const detalles = [
            { campo: "Contrato", anterior: null, nuevo: contratoCodigoTrazabilidad || null },
            { campo: "ONT anterior", anterior: serialOntActual || null, nuevo: null },
            { campo: "ONT nueva", anterior: null, nuevo: serialOntNueva || null },
            { campo: "Traslado inventario", anterior: null, nuevo: codigoTraslado || idTraslado || null },
            { campo: "Acta entrega recepción", anterior: null, nuevo: trasladoPdfUrl || null },
        ];

        await postCrearTrazabilidadCliente({
            cliente: { id_cliente: clienteIdTrazabilidad },
            contrato: { id_contrato: contratoIdTrazabilidad },
            campo_modificado: "Cambio de ONT",
            valor_anterior: serialOntActual,
            valor_nuevo: serialOntNueva,
            tipo_cambio: "CAMBIO_EQUIPO",
            categoria_cambio: "APROVISIONAMIENTO",
            detalle: JSON.stringify(detalles),
            usuario_id: (currentUser as any)?.user_id || (currentUser as any)?.user || (currentUser as any)?.id || 0,
            usuario_nombre: currentUser?.username || "Sistema",
        });

        return true;
    };
    //console.log('datacontrato', dataContrato)
    //Caja primaria
    const rawNapContrato = dataContrato?.data?.nap_data
    const { data: cajasPrimariasPagingRes, isLoading: isloadingRawNapContrato } = useFetchCajasPrimarias({
        enabled: !!rawNapContrato,
        params: { codigo: rawNapContrato?.caja_primaria }
    })
    //console.log(cajasPrimariasPagingRes)
    const cajaPrimariaOltCodigo = cajasPrimariasPagingRes?.data.data.find(
        x => x?.codigo == rawNapContrato?.caja_primaria
    )?.olt;
    const { data: oltsPagingRes, isLoading: isLoadingOlts } = useFetchOLTs({
        enabled: !!cajaPrimariaOltCodigo && (cajasPrimariasPagingRes.data.data.length || 0) > 0,
        params: { page_size: 700, codigo: cajaPrimariaOltCodigo }

    })
    const { data: routersPagingRes, isLoading: isLoadingRouters } = useFetchRouters(
        { page_size: 700, olt: rawNapContrato?.olt },
        !!rawNapContrato
    );
    //console.log(routersPagingRes, isLoadingRouters)
    const { data: brasPagingRes } = useFetchGetBras({
        enabled: (oltsPagingRes?.data?.data?.[0]?.es_bras ?? false),
        params: {
            codigo:
                oltsPagingRes?.data?.data?.[0]?.bras ||
                oltsPagingRes?.data?.data?.[0]?.bras_backup ||
                "",
        },
    });

    //console.log(brasPagingRes)
    const isGestionada = ordenTrabajo.estado_activacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA;

    //const watchFechaUltimaActivacion = useWatch({ control: form.control, name: 'fecha_ultima_activacion' });
    //const watchEstadoNavegacion = useWatch({ control: form.control, name: 'estado_navegacion' });

    //const estadoNavegacionCliente = watchEstadoNavegacion != EstadosNavegacionEnum.ACTIVO;
    const [loading, setLoading] = useState(false)
    const [guardandoPuntos, setGuardandoPuntos] = useState(false)
    const [guardandoBorrador, setGuardandoBorrador] = useState(false)

    // Guardar como Borrador: persiste el progreso (conceptos + series + puntos de
    // red + observación) SIN marcar la activación como GESTIONADA ni navegar. Así
    // el gestor puede continuar después. No exige cambio de ONT ni stock (a
    // diferencia de "Finalizar").
    const guardarBorrador = async () => {
        setGuardandoBorrador(true)
        try {
            const agendamientoId =
                (ordenTrabajo as any)?.agendamiento_data?.id_agendamiento ||
                (ordenTrabajo as any)?.agendamiento
            if (agendamientoId) {
                const currentObs = (ordenTrabajo as any)?.agendamiento_data?.observaciones || {}
                await updateAgendamientoConceptos.mutateAsync({
                    id: agendamientoId,
                    data: {
                        observaciones: {
                            ...currentObs,
                            otros_conceptos: conceptos,
                            puntos_red: puntosRed,
                            reinstalacion_ac: reinstalacionAc || null,
                            tipo_instalacion: tipoInstalacion || null,
                            tipo_instalacion_historial: trazaTipoInstalacion(
                                currentObs?.tipo_instalacion,
                                tipoInstalacion,
                                currentObs?.tipo_instalacion_historial,
                                user?.username || [user?.nombre, user?.apellido].filter(Boolean).join(" ").trim() || "—",
                                "activaciones (borrador)"
                            ),
                        },
                    },
                })
            }
            // Guardar la observación de activación en la OT (sin cambiar estado).
            await updateOTNoReturn.mutateAsync({
                id: id!,
                data: { observacion_activacion: form.getValues()?.observacion_activacion || "" },
            })
            toast.success("Borrador guardado. La activación queda pendiente.")
            await refrescarDatos()
        } catch (e) {
            console.error("No se pudo guardar el borrador", e)
            toast.error("No se pudo guardar el borrador.")
        } finally {
            setGuardandoBorrador(false)
        }
    }

    // Guardar puntos de red desde Activaciones. Si `aprobar` es true, marca
    // puntos_red_aprobado (habilita al técnico finalizar). Registra trazabilidad.
    const guardarPuntosRedAct = async (aprobar: boolean) => {
        const agendamientoId =
            (ordenTrabajo as any)?.agendamiento_data?.id_agendamiento ||
            (ordenTrabajo as any)?.agendamiento
        if (!agendamientoId) {
            toast.error("No se pudo resolver el agendamiento.")
            return
        }
        setGuardandoPuntos(true)
        try {
            const currentObs = (ordenTrabajo as any)?.agendamiento_data?.observaciones || {}
            const previos = Array.isArray(currentObs?.puntos_red) ? currentObs.puntos_red : []
            const cambiaron = JSON.stringify(previos) !== JSON.stringify(puntosRed)
            const histPrevio = Array.isArray(currentObs?.puntos_red_historial) ? currentObs.puntos_red_historial : []
            const historial = (cambiaron || aprobar)
                ? [
                      ...histPrevio,
                      {
                          usuario: user?.username || [user?.nombre, user?.apellido].filter(Boolean).join(" ").trim() || "—",
                          fecha: new Date().toISOString(),
                          origen: aprobar ? "activaciones (aprobación)" : "activaciones",
                          anterior: previos,
                          nuevo: puntosRed,
                      },
                  ]
                : histPrevio
            await updateAgendamientoConceptos.mutateAsync({
                id: agendamientoId,
                data: {
                    observaciones: {
                        ...currentObs,
                        puntos_red: puntosRed,
                        puntos_red_historial: historial,
                        puntos_red_aprobado: aprobar,
                    },
                },
            })
            toast.success(aprobar ? "Puntos de red confirmados. El técnico ya puede finalizar." : "Puntos de red guardados.")
        } catch (e) {
            console.error("No se pudo guardar los puntos de red", e)
            toast.error("No se pudo guardar los puntos de red.")
        } finally {
            setGuardandoPuntos(false)
        }
    }

    const onSave = async (data: any, finalizar?: boolean, extraOrdenTrabajoData: any = {}) => {
        // Bloqueo por stock: no permitir guardar si algún concepto no tiene stock
        // suficiente del producto en la ubicación de la flota. Solo se valida si
        // hay flota asignada y el stock ya cargó (evita falso bloqueo por mapa vacío).
        const sinStock =
            ubicacionFlotaAct && !invStockLoading
                ? conceptosSinStock(conceptos, stockPorProducto)
                : [];
        if (sinStock.length) {
            return toast.error(
                `Sin stock suficiente en la flota para: ${sinStock.join(", ")}. Ajusta el concepto o repón inventario.`
            );
        }
        // El ONT solo se exige cuando el técnico reportó cambio de ONT. En las
        // visitas "No requiere cambio" la activación es solo revisión de datos y
        // conceptos, así que NO se bloquea por falta de ONT.
        const requiereCambio = !!ordenTrabajo?.requiere_cambio_ont;
        if (requiereCambio && !data?.equipos_utilizados) {
            return toast.error("Debe seleccionar un ONT del stock.");
        }
        const router = dataContrato?.data?.router || ordenTrabajo?.router;
        const nap = dataContrato?.data?.nap || ordenTrabajo?.nap;
        const olt = dataContrato?.data?.olt || ordenTrabajo?.olt;
        const puerto = dataContrato?.data?.puerto || ordenTrabajo?.puerto;
        const nodo = dataContrato?.data?.nodo || ordenTrabajo?.nodo;

        // Persistir "Otros conceptos" en el agendamiento (merge de observaciones).
        // Si Activaciones cambió los conceptos, se anexa la trazabilidad
        // (usuario/fecha/antes→después) a observaciones.otros_conceptos_historial
        // para verla en "Calidad de Visitas". Best-effort: no frena la
        // finalización de la activación.
        const agendamientoId =
            (ordenTrabajo as any)?.agendamiento_data?.id_agendamiento ||
            (ordenTrabajo as any)?.agendamiento;
        if (puedeEditarConceptos && agendamientoId) {
            const currentObs = (ordenTrabajo as any)?.agendamiento_data?.observaciones || {};
            const originalConceptos = Array.isArray(currentObs?.otros_conceptos)
                ? currentObs.otros_conceptos
                : [];
            const cambiaron =
                JSON.stringify(originalConceptos) !== JSON.stringify(conceptos);
            // Trazabilidad: si Activaciones cambió los conceptos, se registra
            // quién / cuándo / antes → después para mostrarlo en "Calidad de Visitas".
            const historialPrevio = Array.isArray(currentObs?.otros_conceptos_historial)
                ? currentObs.otros_conceptos_historial
                : [];
            const historial = cambiaron
                ? [
                      ...historialPrevio,
                      {
                          usuario:
                              user?.username ||
                              [user?.nombre, user?.apellido].filter(Boolean).join(" ").trim() ||
                              (user as any)?.razon_social ||
                              "—",
                          fecha: new Date().toISOString(),
                          origen: "activaciones",
                          anterior: originalConceptos,
                          nuevo: conceptos,
                      },
                  ]
                : historialPrevio;
            try {
                await updateAgendamientoConceptos.mutateAsync({
                    id: agendamientoId,
                    data: {
                        observaciones: {
                            ...currentObs,
                            otros_conceptos: conceptos,
                            otros_conceptos_historial: historial,
                            reinstalacion_ac: reinstalacionAc || null,
                            tipo_instalacion: tipoInstalacion || null,
                            tipo_instalacion_historial: trazaTipoInstalacion(
                                currentObs?.tipo_instalacion,
                                tipoInstalacion,
                                currentObs?.tipo_instalacion_historial,
                                user?.username || [user?.nombre, user?.apellido].filter(Boolean).join(" ").trim() || "—",
                                "activaciones"
                            ),
                        },
                    },
                });
            } catch (e) {
                console.error("No se pudo guardar 'Otros conceptos' en el agendamiento", e);
            }
        }

        if (finalizar) {
            if (requiereCambio) {
                //actualiza ot: activación con cambio de ONT
                await updateOT.mutateAsync({
                    id: id!,
                    data: {
                        estado_activacion: EstadosActivacionInstallOTEnumChoice.GESTIONADA,
                        equipos_utilizados: data.equipos_utilizados,
                        ...extraOrdenTrabajoData
                        //fecha_ultima_activacion: dayjs().toISOString(),
                        //router,nap, olt, puerto, nodo
                    }
                })
                await updateContratoNavegacion.mutateAsync({
                    id: ordenTrabajo?.contrato_data?.id_contrato!,
                    data: { nap, router, olt, puerto, nodo }
                })
            } else {
                // "No requiere cambio de ONT": no hay activación que completar ni
                // servicio que activar. Los conceptos ya se guardaron arriba; solo
                // confirmamos y volvemos al listado (la OT sigue pendiente hasta que
                // el técnico finalice la visita, y los conceptos quedan editables).
                toast.success("Conceptos guardados")
                navigate(customReturnUrl)
            }

        } else {
            //actiliza cuando cofirma cambio ONT
            await updateOTNoReturn.mutateAsync({
                id: id!,
                data: {
                    equipos_utilizados: data.equipos_utilizados,
                    ...extraOrdenTrabajoData,
                }
            })

        }
        //form.setValue('fecha_ultima_activacion', dayjs().toISOString())
    }
   const [isSubmitLoadingONT, setIsSubmitLoadingONT]=useState(false)
    const handleDownloadTrasladoPdf = () => {
        if (!trasladoInventarioPdfUrl) return;
        window.open(trasladoInventarioPdfUrl, "_blank", "noopener,noreferrer");
    };

    const handleConfirmarCambioONT = () => {
        console.log("Payload cambiarEquipo", {
            payload: payloadCambioEquipo,
            campos_faltantes: camposFaltantesCambioEquipo,
            aprovisionamiento,
            ont_nueva: selectedNewOnt,
        });
        setLoading(true)
        form.handleSubmit(
            async (d) => {
                try {
                    if (!ontActualGuardada) {
                        showCambioOntDialog({
                            severity: "warning",
                            title: "Falta seleccionar la ONT actual",
                            message: "Primero debe solicitar el cambio de ONT desde la pantalla del técnico y seleccionar la ONT actual instalada.",
                        });
                        return;
                    }

                    if (camposFaltantesTrasladoInventario.length > 0) {
                        showCambioOntDialog({
                            severity: "warning",
                            title: "Faltan datos de inventario",
                            message: "No se puede iniciar el cambio de ONT porque faltan datos para trasladar la ONT nueva.",
                            details: [formatMissingFields(camposFaltantesTrasladoInventario)],
                        });
                        return;
                    }

                    if (camposFaltantesCambioEquipo.length > 0) {
                        showCambioOntDialog({
                            severity: "warning",
                            title: "Faltan datos técnicos",
                            message: "No se puede iniciar el cambio de ONT porque faltan datos para provisionamiento.",
                            details: [formatMissingFields(camposFaltantesCambioEquipo)],
                        });
                        return;
                    }

                    if (esMismaOntActualYNueva) {
                        showCambioOntDialog({
                            severity: "warning",
                            title: "ONT repetida",
                            message: "La ONT nueva no puede ser la misma que la ONT actual seleccionada por el técnico.",
                        });
                        return;
                    }

                    const validacionSeries = await postValidarSeriesEnOrigen({
                        ubicacion_origen: ubicacionOrigenTraslado,
                        producto: productoOntNueva,
                        series: [serialOntNueva],
                    });

                    if (!validacionSeries.todas_disponibles) {
                        showCambioOntDialog({
                            severity: "error",
                            title: "Serie no disponible",
                            message: "No se puede continuar porque la ONT nueva no está disponible en la ubicación origen.",
                            details: [`Serie: ${validacionSeries.series_no_encontradas.join(', ')}`],
                        });
                        return;
                    }

                    let cambioEquipoResp;
                    try {
                        cambioEquipoResp = await postCambiarEquipoProvisionamiento(payloadCambioEquipo);
                    } catch (error) {
                        showCambioOntDialog({
                            severity: "error",
                            title: "Error al cambiar el equipo",
                            message: getProvisionamientoErrorMessage(error),
                            details: ["No se ejecutó el traslado de inventario."],
                        });
                        return;
                    }

                    let trasladoResp;
                    try {
                        trasladoResp = await trasladoInventarioMutation.mutateAsync(payloadTrasladoInventario as any);
                    } catch (error) {
                        let reversaCambioEquipoResp = null;
                        let reversaCambioEquipoError = null;

                        try {
                            reversaCambioEquipoResp = await postCambiarEquipoProvisionamiento(payloadCambioEquipoReversa);
                        } catch (reversaError) {
                            reversaCambioEquipoError = reversaError;
                        }

                        const reversaRealizada = !reversaCambioEquipoError;
                        const mensajeInventario = getApiErrorMessage(error, "No se pudo realizar el traslado de inventario.");
                        const observacionCambioOntParcial = {
                            ...(ordenTrabajo?.observaciones?.observacion_cambio_ont || {}),
                            ont_actual: ontActualGuardada || null,
                            ont_nueva: selectedNewOnt,
                            cambio_equipo: (cambioEquipoResp as any)?.data || cambioEquipoResp,
                            cambio_equipo_reversa: {
                                estado: reversaRealizada ? "OK" : "ERROR",
                                fecha: dayjs().toISOString(),
                                payload: payloadCambioEquipoReversa,
                                respuesta: reversaRealizada
                                    ? ((reversaCambioEquipoResp as any)?.data || reversaCambioEquipoResp)
                                    : null,
                                mensaje: reversaRealizada
                                    ? "Reversa de cambio de equipo realizada porque falló el traslado de inventario."
                                    : getProvisionamientoErrorMessage(reversaCambioEquipoError),
                            },
                            traslado_inventario: {
                                estado: "ERROR",
                                requiere_revision_manual: !reversaRealizada,
                                cambio_equipo_revertido: reversaRealizada,
                                mensaje: mensajeInventario,
                                fecha: dayjs().toISOString(),
                                payload: payloadTrasladoInventario,
                            },
                        };

                        await updateOTNoReturn.mutateAsync({
                            id: id!,
                            data: {
                                observaciones: {
                                    ...(ordenTrabajo?.observaciones || {}),
                                    observacion_cambio_ont: observacionCambioOntParcial,
                                },
                            },
                        });

                        if (reversaRealizada) {
                            showCambioOntDialog({
                                severity: "warning",
                                title: "Inventario no pudo trasladarse",
                                message: mensajeInventario,
                                details: ["Se revirtió el cambio de equipo y las series quedaron como estaban originalmente."],
                            });
                        } else {
                            showCambioOntDialog({
                                severity: "error",
                                title: "Revisión manual requerida",
                                message: "El cambio de equipo se realizó, falló inventario y también falló la reversa automática.",
                                details: [
                                    mensajeInventario,
                                    "Revise manualmente el estado del equipo y del inventario antes de intentar nuevamente.",
                                ],
                            });
                        }
                        return;
                    }

                    const trasladoData = (trasladoResp as any)?.data || trasladoResp;
                    const trasladoPdfUrl = getTrasladoInventarioPdfUrl(trasladoResp);
                    if (!isBlank(trasladoPdfUrl)) {
                        setTrasladoInventarioPdfUrl(trasladoPdfUrl);
                    }
                    const observacionCambioOnt = {
                        ...(ordenTrabajo?.observaciones?.observacion_cambio_ont || {}),
                        ont_actual: ontActualGuardada || null,
                        ont_nueva: selectedNewOnt,
                        cambio_equipo: (cambioEquipoResp as any)?.data || cambioEquipoResp,
                        traslado_inventario: {
                            id_traslado_inventario: trasladoData?.data?.id_traslado_inventario || trasladoData?.id_traslado_inventario,
                            codigo: trasladoData?.data?.codigo || trasladoData?.codigo,
                            url_pdf: trasladoPdfUrl || null,
                            fecha: payloadTrasladoInventario.fecha,
                        },
                    };

                    await onSave(d, false, {
                        observaciones: {
                            ...(ordenTrabajo?.observaciones || {}),
                            observacion_cambio_ont: observacionCambioOnt,
                        },
                    })

                    try {
                        await registrarTrazabilidadCambioOnt({ trasladoData, trasladoPdfUrl });
                    } catch (error) {
                        console.warn("Cambio de equipo completado, pero no se pudo registrar trazabilidad.", error);
                        toast.warning("Cambio realizado. No se pudo registrar la trazabilidad en Vision360.");
                    }

                    setIsSubmitLoadingONT(true)
                    toast.success("Cambio de equipo y traslado de inventario realizados correctamente.");
                } finally {
                    setLoading(false)
                }
            },
        )()
    }

    return (
        <SingleFormBoxScene
            titlePage={titlePage}
            containerMaxWidth="xl"
            formWidth={{ xs: "100%", sm: "96%", md: "92%" }}
            showActionBtns={
                ordenTrabajo?.estado_activacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA ||
                ordenTrabajo?.estado_activacion ==EstadosActivacionInstallOTEnumChoice.RECHAZADA
                ? false:true
            }
            saveTextBtn={ordenTrabajo?.requiere_cambio_ont ? "Guardar Y Finalizar Activación" : "Guardar conceptos"}
            onCancel={() => navigate(customReturnUrl)}
            showCustomBtns={true}
            customBtns={
                (ordenTrabajo?.estado_activacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA ||
                    ordenTrabajo?.estado_activacion === EstadosActivacionInstallOTEnumChoice.RECHAZADA)
                    ? null
                    : (
                        <Grid container item justifyContent="flex-end" spacing={1} alignItems="center">
                            {!hayCambiosAct && (
                                <Grid item>
                                    <Typography variant="caption" color="success.main">
                                        ✓ Sin cambios por guardar
                                    </Typography>
                                </Grid>
                            )}
                            <Grid item>
                                <LoadingButton
                                    variant="outlined"
                                    color="primary"
                                    loading={guardandoBorrador}
                                    disabled={!hayCambiosAct}
                                    onClick={guardarBorrador}
                                >
                                    Guardar Borrador
                                </LoadingButton>
                            </Grid>
                            {hasPermission(PermissionsEnum.administration_manage_system) && (
                                <Grid item>
                                    <LoadingButton
                                        variant="outlined"
                                        color="primary"
                                        loading={liberando}
                                        onClick={liberarOTTecnico}
                                    >
                                        Liberar OT Técnico
                                    </LoadingButton>
                                </Grid>
                            )}
                        </Grid>
                    )
            }
            onSave={form.handleSubmit(() => onSave(form.getValues(), true), (error) => {
                console.log(error)
                toast.error("debes completar los campos requeridos.")
            })}
        >
            <Grid container spacing={2} >
                {/* Tiempos del técnico EN TIEMPO REAL (cronómetro en vivo; poll ligero) */}
                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2 }}>
                        <TiemposVisita ot={otTiempos} />
                    </Paper>
                </Grid>
                {form.getValues()?.estado_activacion !== EstadosActivacionInstallOTEnumChoice.GESTIONADA ?
                    form.getValues().fecha_hora_inicio_visita ?
                        ordenTrabajo.requiere_cambio_ont === undefined || ordenTrabajo.requiere_cambio_ont === null ?
                            <CustomAlertCard
                                alertColor="warning"
                                alertTitle="Nota"
                                alertMessage={`Orden de trabajo iniciada a las ${dayjs(form.getValues()?.fecha_hora_inicio_visita).format('HH:mm:ss DD/MM/YYYY')}. Requiere confirmación de cambio de ONT, sin esto no puede continuar.`}
                                bgColorAlert="SKY"
                            />
                            :
                            <CustomAlertCard
                                alertColor="info"
                                alertTitle="Nota"
                                alertMessage={`${texto.orden_trabajo_iniciada} Iniciada a las ${dayjs(form.getValues()?.fecha_hora_inicio_visita).format('HH:mm:ss DD/MM/YYYY')}`}
                                bgColorAlert="GREEN"
                            />
                        :
                        <CustomAlertCard
                            alertColor='info'
                            alertTitle="Nota"
                            alertMessage={texto.orden_trabajo_no_iniciada}
                            bgColorAlert="YELLOW" />

                    : null
                }
                <Grid item {...gridSizeMdLg6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1 }}>
                        <PersonIcon sx={{ color: 'primary.main', fontSize: 22 }} />
                        <TabTextLabel
                            text={"DATOS DEL CLIENTE"}
                            mt={0}
                            pb={0}
                            pl={0}
                            variant="h4"
                            uppercase={true}
                            color="#757de8"
                        />

                    </Box>
                    <ClienteFormComponetVisita form={form} />
                </Grid>
                <Grid item {...gridSizeMdLg6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1 }}>
                        <CalendarMonthIcon sx={{ color: 'primary.main', fontSize: 22 }} />
                        <TabTextLabel
                            text={"DATOS DE visita"}
                            mt={0}
                            pb={0}
                            pl={0}
                            variant="h4"
                            uppercase={true}
                            color="#757de8"
                        />

                    </Box>

                    <Grid container spacing={2}>
                        <Grid item >
                            <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 500, display: 'block' }}>
                                Flota asignada
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500 }}>
                                {ordenTrabajo?.flota_data?.nombre || 'N/A'}
                            </Typography>
                        </Grid>
                        <Grid item >
                            <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 500, display: 'block' }}>
                                Fecha de visita
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500 }}>
                                {ordenTrabajo?.fecha_visita || 'N/A'}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 500, display: 'block' }}>
                                Hora de visita
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500 }}>
                                {ordenTrabajo?.hora_visita || 'N/A'}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 500, display: 'block' }}>
                                Inicio visita
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500 }}>
                                {ordenTrabajo?.fecha_hora_inicio_visita
                                    ? dayjs(ordenTrabajo.fecha_hora_inicio_visita).format('DD/MM/YYYY HH:mm')
                                    : 'No iniciada'}
                            </Typography>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item {...gridSizeMdLg12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 2 }}>
                        <EngineeringIcon sx={{ color: 'primary.main', fontSize: 22 }} />
                        <TabTextLabel
                            text={"Activación - DATOS DE técnico"}
                            mt={0}
                            pb={0}
                            pl={0}
                            variant="h4"
                            uppercase={true}
                            color="#757de8"
                        />
                    </Box>

                    {form.getValues().fecha_hora_inicio_visita ?
                        ordenTrabajo.requiere_cambio_ont === undefined || ordenTrabajo.requiere_cambio_ont === null ?
                            <CustomAlertCard
                                alertColor="warning"
                                alertTitle="Nota"
                                alertMessage={`Orden de trabajo iniciada a las ${dayjs(form.getValues()?.fecha_hora_inicio_visita).format('HH:mm:ss DD/MM/YYYY')}. Requiere confirmación de cambio de ONT, sin esto no puede continuar.`}
                                bgColorAlert="SKY"
                            />
                            :
                            ordenTrabajo?.requiere_cambio_ont ? (
                            <Grid container spacing={2}>
                                {(isLoadingContrato || isloadingRawNapContrato || isLoadingOlts || isLoadingRouters) ? (
                                    <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                                        <CircularProgress />
                                    </Grid>

                                ) : (
                                    <>
                                        <CustomTextFieldNoForm
                                            label="Caja Primaria"
                                            value={cajasPrimariasPagingRes?.data?.data?.filter(
                                                x => x?.codigo == rawNapContrato?.caja_primaria
                                            )?.[0]?.nombre || 'N/D'}
                                            size={gridSizeMdLg6}
                                            disabled
                                        />
                                        <CustomTextFieldNoForm
                                            label="OLT"
                                            value={oltsPagingRes?.data?.data?.[0]?.nombre || 'N/D'}
                                            size={gridSizeMdLg6}
                                            disabled
                                        />
                                        {oltsPagingRes?.data?.data?.[0]?.es_bras ? (
                                            <>
                                                <CustomTextFieldNoForm
                                                    label="BRAS"
                                                    value={brasPagingRes?.data?.data?.[0].nombre || 'N/D'}
                                                    size={gridSizeMdLg6}
                                                    disabled
                                                />
                                                <CustomTextFieldNoForm
                                                    label="IP de BRAS"
                                                    value={brasPagingRes?.data?.data?.[0]?.hostname || 'N/D'}
                                                    size={gridSizeMdLg6}
                                                    disabled
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <CustomTextFieldNoForm
                                                    label="Router"
                                                    value={routersPagingRes?.data?.data?.find(f => f.codigo === ordenTrabajo?.router)?.nombre || 'No registrado'}
                                                    size={gridSizeMdLg6}
                                                    disabled
                                                />
                                                <CustomTextFieldNoForm
                                                    label="IP del Router"
                                                    value={routersPagingRes?.data?.data?.find(m => m.codigo === ordenTrabajo?.router)?.ip || 'No registrado'}
                                                    disabled
                                                    size={gridSizeMdLg6}
                                                />
                                            </>

                                        )}
                                        <CustomTextFieldNoForm
                                            label="IPv4"
                                            value={dataContrato?.data?.ipv4_actual || 'No registrado'}
                                            size={gridSizeMdLg6}
                                            disabled
                                        />
                                        <CustomTextFieldNoForm
                                            label="PPPoE"
                                            value={dataContrato?.data?.pppoe || 'No registrado'}
                                            size={gridSizeMdLg6}
                                            disabled
                                        />
                                    </>
                                )}
                                <Grid item {...gridSizeMdLg12}>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            p: 1,
                                            borderRadius: 2,
                                            bgcolor: ordenTrabajo?.requiere_cambio_ont
                                                ? (t) => alpha(t.palette.primary.main, 0.08)
                                                : '#f5f5f5',
                                            border: ordenTrabajo?.requiere_cambio_ont
                                                ? (t) => `1px solid ${alpha(t.palette.primary.main, 0.3)}`
                                                : '1px solid #e0e0e0',
                                        }}
                                    >
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={12} display="flex" alignItems="center" gap={1.5}>
                                                <MemoryIcon
                                                    sx={{
                                                        fontSize: 28,
                                                        color: ordenTrabajo?.requiere_cambio_ont ? 'primary.main' : '#9e9e9e',
                                                    }}
                                                />
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography variant="subtitle2" fontWeight={700} color="text.primary">
                                                        Solicitud de cambio de ONT
                                                    </Typography>
                                                    <Typography variant="caption" color="text.secondary">
                                                        {ordenTrabajo?.requiere_cambio_ont
                                                            ? 'El técnico reportó que se requiere un cambio de equipo ONT'
                                                            : 'El técnico no reportó novedades con el equipo ONT'
                                                        }
                                                    </Typography>
                                                </Box>
                                                {ordenTrabajo?.requiere_cambio_ont ? (
                                                    <Chip
                                                        label="Solicitado"
                                                        size="small"
                                                        color="primary"
                                                        sx={{ fontWeight: 700, fontSize: '0.7rem' }}
                                                    />
                                                ) : (
                                                    <Chip
                                                        label="Sin novedad"
                                                        size="small"
                                                        variant="outlined"
                                                        color="default"
                                                        sx={{ fontWeight: 600, fontSize: '0.7rem' }}
                                                    />
                                                )}
                                            </Grid>

                                            {ordenTrabajo?.requiere_cambio_ont && (
                                                <Grid item xs={12}>
                                                    <CustomTextField
                                                        label="Motivo reportado por el técnico"
                                                        name="motivo_cambio_ont"
                                                        control={form.control}
                                                        defaultValue={ordenTrabajo?.motivo_cambio_ont || ""}
                                                        error={false}
                                                        helperText={false}
                                                        size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                                                        disabled
                                                    />
                                                </Grid>
                                            )}

                                            {ordenTrabajo?.requiere_cambio_ont && (
                                                <Grid item xs={12}>
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            p: 1.5,
                                                            borderRadius: 1.5,
                                                            bgcolor: '#fff',
                                                            border: '1px dashed #ffb74d',
                                                        }}
                                                    >
                                                        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                                                            Datos para cambio de ONT
                                                        </Typography>
                                                        {isLoadingAprovisionamiento ? (
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <CircularProgress size={16} />
                                                                <Typography variant="caption" color="text.secondary">
                                                                    Consultando aprovisionamiento...
                                                                </Typography>
                                                            </Box>
                                                        ) : (
                                                            <>
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography variant="caption" color="text.secondary">Identificación consulta</Typography>
                                                                        <Typography variant="body2" fontWeight={600}>{clienteIdentificacion || '-'}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography variant="caption" color="text.secondary">Contrato consulta</Typography>
                                                                        <Typography variant="body2" fontWeight={600}>{contratoCodigoAprovisionamiento || '-'}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography variant="caption" color="text.secondary">Aprovisionamiento</Typography>
                                                                        <Typography variant="body2" fontWeight={600}>
                                                                            {aprovisionamiento ? 'Encontrado' : 'Sin datos'}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography variant="caption" color="text.secondary">ONT actual</Typography>
                                                                        <Typography variant="body2" fontWeight={600}>{serialOntActual || '-'}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography variant="caption" color="text.secondary">ONT nueva</Typography>
                                                                        <Typography variant="body2" fontWeight={600}>{serialOntNueva || '-'}</Typography>
                                                                    </Grid>
                                                                </Grid>

                                                                {esMismaOntActualYNueva ? (
                                                                    <Alert severity="error" sx={{ mt: 1.5 }}>
                                                                        La ONT nueva seleccionada es la misma que la ONT actual. Selecciona una ONT distinta para continuar.
                                                                    </Alert>
                                                                ) : camposFaltantesCambioEquipo.length > 0 ? (
                                                                    <Alert severity="warning" sx={{ mt: 1.5 }}>
                                                                        No está listo para cambiar equipo. Falta información de aprovisionamiento: {formatMissingFields(camposFaltantesCambioEquipo)}.
                                                                    </Alert>
                                                                ) : (
                                                                    <Alert severity="success" sx={{ mt: 1.5 }}>
                                                                        Información completa para cambiar equipo.
                                                                    </Alert>
                                                                )}
                                                            </>
                                                        )}
                                                    </Paper>
                                                </Grid>
                                            )}

                                            {ordenTrabajo?.requiere_cambio_ont && (
                                                <Grid item xs={12}>
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            p: 1.5,
                                                            borderRadius: 1.5,
                                                            bgcolor: '#fff',
                                                            border: '1px dashed #90caf9',
                                                        }}
                                                    >
                                                        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                                                            Traslado de inventario
                                                        </Typography>
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={12} md={3}>
                                                                <Typography variant="caption" color="text.secondary">Bodega origen</Typography>
                                                                <Typography variant="body2" fontWeight={600}>{bodegaOrigenTraslado || '-'}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={3}>
                                                                <Typography variant="caption" color="text.secondary">Ubicación origen</Typography>
                                                                <Typography variant="body2" fontWeight={600}>{ubicacionOrigenTraslado || '-'}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={3}>
                                                                <Typography variant="caption" color="text.secondary">Bodega destino</Typography>
                                                                <Typography variant="body2" fontWeight={600}>{bodegaDestinoTraslado || '-'}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={3}>
                                                                <Typography variant="caption" color="text.secondary">Ubicación destino</Typography>
                                                                <Typography variant="body2" fontWeight={600}>{ubicacionDestinoTraslado || '-'}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Typography variant="caption" color="text.secondary">Producto ONT nueva</Typography>
                                                                <Typography variant="body2" fontWeight={600}>{productoOntNueva || '-'}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Typography variant="caption" color="text.secondary">Serie ONT nueva</Typography>
                                                                <Typography variant="body2" fontWeight={600}>{serialOntNueva || '-'}</Typography>
                                                            </Grid>
                                                        </Grid>

                                                        {camposFaltantesTrasladoInventario.length > 0 ? (
                                                            <Alert severity="warning" sx={{ mt: 1.5 }}>
                                                                No está listo para trasladar la ONT. Falta completar: {formatMissingFields(camposFaltantesTrasladoInventario)}.
                                                            </Alert>
                                                        ) : (
                                                            <Alert severity="success" sx={{ mt: 1.5 }}>
                                                                Datos completos para validar serie y crear traslado de inventario.
                                                            </Alert>
                                                        )}
                                                        <Box sx={{ mt: 1.5, display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1 }}>
                                                            <Typography variant="caption" color="text.secondary" fontWeight={700}>
                                                                ACTA DE ENTREGA RECEPCIÓN DE INVENTARIO
                                                            </Typography>
                                                            <Tooltip
                                                                title={
                                                                    trasladoInventarioPdfUrl
                                                                        ? "Abrir PDF generado del traslado"
                                                                        : "El botón se habilita cuando inventario genera el PDF"
                                                                }
                                                            >
                                                                <span>
                                                                    <Button
                                                                        size="small"
                                                                        variant="outlined"
                                                                        startIcon={<PictureAsPdfIcon />}
                                                                        disabled={!trasladoInventarioPdfUrl}
                                                                        onClick={handleDownloadTrasladoPdf}
                                                                    >
                                                                        {trasladoInventarioPdfUrl ? "Descargar PDF" : "PDF no generado"}
                                                                    </Button>
                                                                </span>
                                                            </Tooltip>
                                                        </Box>
                                                    </Paper>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Paper>

                                </Grid>

                                {ordenTrabajo?.requiere_cambio_ont && (
                                <Grid item {...gridSizeMdLg12}>
                                    <Grid container spacing={2} justifyContent={"space-between"}>
                                        <Grid item>
                                            <Typography variant="subtitle2" fontWeight={600} color="text.primary" sx={{
                                                mb: 1.5, display: 'flex',
                                                alignItems: 'center', gap: 0.5
                                            }}>
                                                <MemoryIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                                                Asignar nuevo ONT
                                            </Typography>
                                        </Grid>

                                        {isloadingUbProducto ? (
                                            <Grid container justifyContent="center" alignItems="center" sx={{ height: 56 }}>
                                                <CircularProgress size={24} />
                                            </Grid>
                                        ) : (
                                            <CustomAutocompleteNoForm<ONTOption>
                                                label="Seleccionar ONT del stock"
                                                valueKey="name"
                                                actualValueKey="value"
                                                options={optionsONT || []}
                                                isLoadingData={isloadingUbProducto}
                                                defaultValue={form.getValues().ont_a_utilizar || null}
                                                onChangeRawValue={value => {
                                                    form.reset({
                                                        ...form.getValues(),
                                                        ont_a_utilizar: value,
                                                        equipos_utilizados: [value],
                                                    })
                                                }}
                                                size={gridSizeMdLg12}
                                                disabled={ loading || isSubmitLoadingONT ||
                                                    !!selectedNewOnt ||
                                                    (form.getValues().equipos_utilizados?.length ?? 0) >= 1
                                                }
                                            />
                                        )}

                                        <Grid item {...gridSizeMdLg12}>

                                                <LoadingButton
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    size="large"
                                                    disabled={isGestionada || loading || trasladoInventarioMutation.isPending || isSubmitLoadingONT|| (ordenTrabajo?.equipos_utilizados?.length ?? 0) >= 1}
                                                    loading={loading || trasladoInventarioMutation.isPending}
                                                    loadingPosition="end"
                                                    onClick={handleConfirmarCambioONT}
                                                >
                                                    {loading ? "Asignando..." : "Confirmar cambio de ONT"}
                                                </LoadingButton>
                                            </Grid>


                                    </Grid>
                                </Grid>
                                )}
                            </Grid>
                            ) : (
                            <CustomAlertCard
                                alertColor="info"
                                alertTitle="Sin cambio de ONT"
                                alertMessage="El técnico no reportó cambio de ONT: esta visita no requiere activación. Puedes agregar o quitar los conceptos / ventas adicionales abajo (si el cliente lo necesita) y guardar."
                                bgColorAlert="GREEN"
                            />
                            )
                        :
                        <CustomAlertCard
                            alertColor='info'
                            alertTitle="Nota"
                            alertMessage={texto.orden_trabajo_no_iniciada}
                            bgColorAlert="YELLOW" />
                    }
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, py: 1, flexWrap: 'wrap' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <AssignmentIcon sx={{ color: 'primary.main', fontSize: 22 }} />
                            <Typography variant="subtitle1" sx={{ color: 'text.primary', fontWeight: 700 }}>
                                DATOS ADICIONALES
                            </Typography>
                        </Box>
                        <LoadingButton
                            variant="outlined"
                            color="success"
                            size="small"
                            startIcon={<RefreshIcon />}
                            loading={actualizando}
                            onClick={refrescarDatos}
                        >
                            Actualizar
                        </LoadingButton>
                    </Box>
                    <Grid container spacing={2}>
                        {/* "Equipos Adicionales para la Venta" se unificó en "Otros
                            conceptos" (concepto + producto + precio + método). El acta/PDF
                            se alimenta de otros_conceptos en el backend. */}
                        <Grid item xs={12}>
                            <CustomTextArea
                                label="Observación de Activación"
                                name="observacion_activacion"
                                control={form.control}
                                defaultValue={form.getValues()?.observacion_activacion || ''}
                                error={form.formState.errors.observacion_activacion as any}
                                helperText={form.formState.errors.observacion_activacion?.message as any}
                                disabled={isGestionada}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <TipoInstalacionSelector
                                value={tipoInstalacion}
                                onChange={setTipoInstalacion}
                                readOnly={!puedeEditarConceptos}
                                tipos={tiposInstalacion}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <Paper variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2 }}>
                                <ReinstalacionAcVisita
                                    value={reinstalacionAc}
                                    onChange={setReinstalacionAc}
                                    readOnly={!puedeEditarConceptos}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <OtrosConceptosVisita
                                value={conceptos}
                                onChange={setConceptos}
                                readOnly={!puedeEditarConceptos}
                                conceptos={catalogoConceptos}
                                metodosPago={metodosPago}
                                stockPorProducto={stockPorProducto}
                                ubicacionFlota={ubicacionFlotaAct}
                            />
                        </Grid>
                        {/* Puntos de red: ingresados por el técnico; activaciones edita/aprueba */}
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <PuntosDeRedVisita
                                value={puntosRed}
                                onChange={setPuntosRed}
                                readOnly={!puedeEditarConceptos}
                                config={puntoRedConfig}
                                ivaPorcentaje={ivaPorcentajePR}
                                tieneCableUtp={tieneCableUtpAct}
                                conceptosDisponibles={conceptos
                                    .filter((c) => catalogoConceptos.find((cat) => cat.concepto === c.concepto)?.permite_punto_red)
                                    .map((c) => c.concepto)
                                    .filter((v, i, a) => !!v && a.indexOf(v) === i)}
                            />
                            {puedeEditarConceptos && (
                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-end', mt: 1 }}>
                                    {!puntosDirtyAct && puntosRed.length > 0 && (
                                        <Typography variant="caption" color="success.main">
                                            ✓ Guardado{puntosRedAprobadoAct ? ' y aprobado' : ' (pendiente de aprobación)'}
                                        </Typography>
                                    )}
                                    <LoadingButton
                                        variant="outlined"
                                        color="secondary"
                                        loading={guardandoPuntos}
                                        disabled={!puntosDirtyAct}
                                        onClick={() => guardarPuntosRedAct(false)}
                                    >
                                        Guardar puntos de red
                                    </LoadingButton>
                                    <LoadingButton
                                        variant="contained"
                                        color="success"
                                        loading={guardandoPuntos}
                                        disabled={puntosRedAprobadoAct && !puntosDirtyAct}
                                        onClick={() => guardarPuntosRedAct(true)}
                                    >
                                        {puntosRedAprobadoAct ? "Puntos aprobados ✓ (reconfirmar)" : "Confirmar puntos de red"}
                                    </LoadingButton>
                                </Box>
                            )}
                        </Grid>
                        {/* Evidencia fotográfica (solo lectura): las fotos que
                            subió el técnico durante la visita (ingreso / proceso /
                            finalización), en una sola vista ordenada. */}
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Paper variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2 }}>
                                {/* Mismo mecanismo que traslados: estado en vivo y, con el
                                    módulo ACTIVACIONES.VISITA, botón "Eliminar" en cada foto.
                                    El técnico la ve como faltante y la vuelve a subir. */}
                                <FotosVisitaTab
                                    ordenTrabajo={ordenTrabajo}
                                    readOnly
                                    canDelete={canDeleteFotos}
                                    live
                                    title="Evidencia fotográfica de la visita"
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Dialog
                open={cambioOntDialog.open}
                onClose={() => setCambioOntDialog((prev) => ({ ...prev, open: false }))}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ fontWeight: 700 }}>
                    {cambioOntDialog.title}
                </DialogTitle>
                <DialogContent>
                    <Alert
                        severity={cambioOntDialog.severity}
                        sx={{
                            alignItems: "flex-start",
                            borderRadius: 1.5,
                            "& .MuiAlert-message": { width: "100%" },
                        }}
                    >
                        <Typography variant="body2" fontWeight={600}>
                            {cambioOntDialog.message}
                        </Typography>
                        {cambioOntDialog.details?.length ? (
                            <Box component="ul" sx={{ pl: 2.5, mt: 1, mb: 0 }}>
                                {cambioOntDialog.details.map((detail, index) => (
                                    <Typography component="li" variant="body2" key={`${detail}-${index}`}>
                                        {detail}
                                    </Typography>
                                ))}
                            </Box>
                        ) : null}
                    </Alert>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        variant="contained"
                        onClick={() => setCambioOntDialog((prev) => ({ ...prev, open: false }))}
                    >
                        Entendido
                    </Button>
                </DialogActions>
            </Dialog>

        </SingleFormBoxScene>
    )
}
